module.exports = __webpack_public_path__ + "images/9ee80cc746ce191d02b41fccccccadb2.png";